// External dependencies.
import Moment from 'moment'

// Internal dependencies.
import B64 from '@/filters/base64'
import Translate from '@/filters/translate'

// Components.
import HangingFrame from '@/components/hanging-frame/component'
import Foot from '@/components/foot/component'

// Mixins
import CheckoutMixin from '@/mixins/checkoutMixin'

export default {
  name: 'checkout-confirmation-page',
  components: { HangingFrame, Foot },
  mixins: [CheckoutMixin],
  data () {
    return {
      isOrderReady: false,
      errorMessage: ''
    }
  },
  mounted () {
    if (this.isQliroEnabled) {
      this.$store.dispatch('setAllowClosingBackdrop', false)
      this.$store.dispatch('setOrderState', 'gettingOrder')
      this.$store.dispatch('setBackdropMessage', Translate.translate(this.$store.getters.orderState))
      this.$store.dispatch('showBackdrop', true)

      const self = this
      this.$store.dispatch('getOrder', this.$store.getters.orderId).then(function (getOrderRes) {
        if (self.isOrderDataComplete(getOrderRes.data)) {
          self.setOrderDataToStorage(getOrderRes.data)
          self.isOrderReady = true
          self.$store.dispatch('showBackdrop', false)
          self.$store.dispatch('trackOrderConfirmed', getOrderRes.data)
        } else {
          self.$store.dispatch('syncOrder', self.$store.getters.orderId).then(function () {
            self.$store.dispatch('getOrder', self.$store.getters.orderId).then(function (getOrderRes) {
              if (self.isOrderDataComplete(getOrderRes.data)) {
                self.setOrderDataToStorage(getOrderRes.data)
                self.isOrderReady = true
                self.$store.dispatch('trackOrderConfirmed', getOrderRes.data)
              } else {
                self.handleOrderError('', 'getOrder')
              }
              self.$store.dispatch('showBackdrop', false)
            }).catch(function (response) {
              self.$store.dispatch('showBackdrop', false)
              self.handleOrderError(response.body, 'getOrder')
            })
          }).catch(function (response) {
            self.$store.dispatch('showBackdrop', false)
            self.handleOrderError(response.body, 'syncOrder')
          })
        }
      }).catch(function (response) {
        self.$store.dispatch('showBackdrop', false)
        self.handleOrderError(response.body, 'getOrder')
      })
    } else {
      this.isOrderReady = this.$store.getters.orderConfirmationNumber !== '-'
    }
  },
  computed: {
    posters () {
      return this.$store.getters.cartItems.filter((item) => item.type === 'poster')
    }
  },
  methods: {
    isOrderDataComplete (order) {
      return order.billing &&
        order.billing.address &&
        order.billing.address.firstName !== '' &&
        order.billing.address.lastName !== '' &&
        order.billing.address.email !== '' &&
        order.billing.address.phone !== '' &&
        order.billing.address.street !== '' &&
        order.billing.address.city !== '' &&
        // order.billing.address.state !== '' &&
        order.billing.address.postalCode !== '' &&
        order.billing.address.countryCode !== '' &&
        order.shipping &&
        order.shipping.address &&
        order.shipping.address.firstName !== '' &&
        order.shipping.address.lastName !== '' &&
        order.shipping.address.email !== '' &&
        order.shipping.address.phone !== '' &&
        order.shipping.address.street !== '' &&
        order.shipping.address.city !== '' &&
        // order.shipping.address.state !== '' &&
        order.shipping.address.postalCode !== '' &&
        order.shipping.address.countryCode !== '' &&
        order.shipping.method !== ''
    },

    setOrderDataToStorage (order) {
      this.firstName = order.billing.address.firstName
      this.lastName = order.billing.address.lastName
      this.email = order.billing.address.email
      this.phoneMobile = order.billing.address.phone
      this.address = order.billing.address.street
      this.city = order.billing.address.city
      this.state = order.billing.address.state
      this.postalCode = order.billing.address.postalCode
      this.country = order.billing.address.countryCode.toUpperCase()

      this.deliveryFirstName = order.shipping.address.firstName
      this.deliveryLastName = order.shipping.address.lastName
      this.deliveryEmail = order.shipping.address.email
      this.deliveryPhoneMobile = order.shipping.address.phone
      this.deliveryAddress = order.shipping.address.street
      this.deliveryCity = order.shipping.address.city
      this.deliveryState = order.shipping.address.state
      this.deliveryPostalCode = order.shipping.address.postalCode
      this.deliveryCountry = order.shipping.address.countryCode.toUpperCase()

      this.$store.dispatch(
        'setCheckoutSeparateDeliveryAddress',
        this.firstName !== this.deliveryFirstName ||
        this.lastName !== this.deliveryLastName ||
        this.email !== this.deliveryEmail ||
        this.phoneMobile !== this.deliveryPhoneMobile ||
        this.address !== this.deliveryAddress ||
        this.city !== this.deliveryCity ||
        this.state !== this.deliveryState ||
        this.postalCode !== this.deliveryPostalCode ||
        this.country !== this.deliveryCountry
      )

      this.shippingMethod = { method: order.shipping.method }
    },

    getItemHTML (item) {
      return B64.decode(item.svgB64)
    },

    getMoment (date) {
      return Moment(date)
    }
  },

  destroyed () {
    this.$store.dispatch('emptyCart')
    this.$store.dispatch('clearCheckout')
  }
}



// WEBPACK FOOTER //
// ./src/pages/checkout/confirm/script.js